<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="stock-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form
                ref="requestData"
                v-model="validRequestData"
                @submit.prevent
              >
                <v-row>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="requestData.organization_id"
                      :items="organizations"
                      item-text="label"
                      item-value="id"
                      :label="$t('STOCK.WAREHOUSES.ORGANIZATION') + '*'"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.organization_id || []"
                      clearable
                      @change="setChange('organization_id')"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="requestData.code"
                      :label="$t('STOCK.WAREHOUSES.CODE') + '*'"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.code || []"
                      @change="setChange('code')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="requestData.name"
                      :label="$t('GENERAL.LABELS.NAME') + '*'"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.name || []"
                      @change="setChange('name')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!--
                    TEMP HIDDEN: physical/virtual type switch + virtual subtype.
                    Concept for now: 1 system warehouse per organization; all custom
                    warehouses are physical only. Restore this UI when virtual custom
                    warehouses are needed again.
                  <v-col cols="12" md="4">
                    <v-btn-toggle
                      v-model="requestData.type"
                      mandatory
                      dense
                      class="mt-3"
                      @change="handleTypeChange"
                    >
                      <v-btn value="physical">
                        {{ $t("STOCK.WAREHOUSES.TYPES.PHYSICAL") }}
                      </v-btn>
                      <v-btn value="virtual">
                        {{ $t("STOCK.WAREHOUSES.TYPES.VIRTUAL") }}
                      </v-btn>
                    </v-btn-toggle>
                    <div class="error--text text-caption mt-1">
                      {{ (validationErrors.type || [])[0] }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="requestData.virtual_subtype"
                      :items="virtualSubtypeOptions"
                      item-text="label"
                      item-value="id"
                      :disabled="requestData.type !== 'virtual'"
                      :label="$t('STOCK.WAREHOUSES.VIRTUAL_SUBTYPE')"
                      :error-messages="validationErrors.virtual_subtype || []"
                      clearable
                      @change="setChange('virtual_subtype')"
                    ></v-autocomplete>
                  </v-col>
                  -->
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="requestData.country_id"
                      :items="countries"
                      item-text="label"
                      item-value="id"
                      :label="$t('GENERAL.LABELS.COUNTRY')"
                      :error-messages="validationErrors.country_id || []"
                      clearable
                      @change="setChange('country_id')"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="8">
                    <v-textarea
                      v-model="requestData.address"
                      :label="$t('STOCK.WAREHOUSES.ADDRESS')"
                      :error-messages="validationErrors.address || []"
                      rows="2"
                      auto-grow
                      @change="setChange('address')"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox
                      v-model="requestData.is_active"
                      class="mt-0 mt-md-5"
                      :label="$t('GENERAL.LABELS.ACTIVE')"
                      hide-details
                      color="primary"
                      @change="setChange('is_active')"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="requestData.contact_name"
                      :label="$t('STOCK.WAREHOUSES.CONTACT_NAME')"
                      :error-messages="validationErrors.contact_name || []"
                      @change="setChange('contact_name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="requestData.contact_phone"
                      :label="$t('STOCK.WAREHOUSES.CONTACT_PHONE')"
                      :error-messages="validationErrors.contact_phone || []"
                      @change="setChange('contact_phone')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="requestData.storage_capabilities"
                      :label="$t('STOCK.WAREHOUSES.STORAGE_CAPABILITIES')"
                      :error-messages="validationErrors.storage_capabilities || []"
                      @change="setChange('storage_capabilities')"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="requestData.notice_hours"
                      type="number"
                      min="0"
                      :label="$t('STOCK.WAREHOUSES.NOTICE_HOURS')"
                      :error-messages="validationErrors.notice_hours || []"
                      @change="setChange('notice_hours')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model.number="requestData.capacity_palettes"
                      type="number"
                      min="0"
                      :label="$t('STOCK.WAREHOUSES.CAPACITY_PALETTES')"
                      :error-messages="validationErrors.capacity_palettes || []"
                      @change="setChange('capacity_palettes')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="requestData.user_ids"
                      :items="users"
                      :item-text="userLabel"
                      item-value="id"
                      :label="$t('STOCK.WAREHOUSES.USER_ACCESS')"
                      :error-messages="validationErrors.user_ids || []"
                      multiple
                      chips
                      small-chips
                      clearable
                      @change="setChange('user_ids')"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back(true)">
                {{ $t("GENERAL.LABELS.BACK_BUTTON") }}
              </v-btn>
              <v-btn color="success" @click="store">
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <TPConfirm
      v-model="showConfirmSet"
      content="All current changes will be lost."
      @confirm="back"
    ></TPConfirm>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import TPConfirm from "@/views/partials/dialogs/Confirm.vue";
import userStateService from "@/common/userState.service";
import { SHOW_SNACK } from "@/store/snack.module";
import { GET_COUNTRIES } from "@/store/countries.module";
import { GET_ORGANIZATIONS_OPTIONS } from "@/store/organizations.module";
import { GET_USERS } from "@/store/users.module";
import {
  CREATE_STOCK_WAREHOUSE,
  GET_STOCK_WAREHOUSE,
  UPDATE_STOCK_WAREHOUSE,
} from "@/store/stock/stockWarehouses.module";

export default {
  name: "StockEditWarehouse",
  components: {
    TPConfirm,
  },
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validRequestData: false,
      hasChanges: false,
      showConfirmSet: false,
      validationErrors: {},
      title: this.$t("STOCK.WAREHOUSES.CREATE"),
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      organizations: [],
      countries: [],
      users: [],
      // TEMP HIDDEN with type switch UI — restore when virtual custom warehouses return
      // virtualSubtypeOptions: [
      //   { id: "transit", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.TRANSIT") },
      //   { id: "dropship", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.DROPSHIP") },
      //   { id: "quarantine", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.QUARANTINE") },
      //   { id: "consignment", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.CONSIGNMENT") },
      //   { id: "container", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.CONTAINER") },
      //   { id: "land", label: this.$t("STOCK.WAREHOUSES.VIRTUAL_SUBTYPES.LAND") },
      // ],
      requestData: {
        organization_id: null,
        country_id: null,
        code: "",
        name: "",
        // Custom warehouses are always physical; system warehouse type comes from API on edit
        type: "physical",
        virtual_subtype: null,
        address: "",
        contact_name: "",
        contact_phone: "",
        storage_capabilities: "",
        notice_hours: null,
        capacity_palettes: null,
        is_active: true,
        user_ids: [],
      },
    };
  },
  mounted() {
    this.isProcessing = true;

    Promise.all([
      this.loadOrganizations(),
      this.loadCountries(),
      this.loadUsers(),
    ])
      .then(() => {
        this.selectWarehouse();
      })
      .finally(() => {
        this.isProcessing = false;
      });
  },
  methods: {
    userLabel(user) {
      return `${user.name} <${user.email}>`;
    },
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      return error?.message || this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    setValidationErrors(error) {
      this.validationErrors = (error && error.errors) || {};
    },
    clearValidationError(field) {
      if (!this.validationErrors[field]) {
        return;
      }

      this.$delete(this.validationErrors, field);
    },
    setChange(field) {
      this.hasChanges = true;
      this.clearValidationError(field);
    },
    // TEMP HIDDEN with type switch UI — restore when virtual custom warehouses return
    // handleTypeChange() {
    //   this.hasChanges = true;
    //   this.clearValidationError("type");
    //
    //   if (this.requestData.type === "physical") {
    //     this.requestData.virtual_subtype = null;
    //   }
    // },

    loadOrganizations() {
      return this.$store
        .dispatch(GET_ORGANIZATIONS_OPTIONS, {})
        .then((response) => {
          this.organizations = response.data || [];
        });
    },
    loadCountries() {
      return this.$store
        .dispatch(GET_COUNTRIES)
        .then((response) => {
          this.countries = response.data || [];
        });
    },
    loadUsers() {
      return this.$store
        .dispatch(GET_USERS)
        .then((response) => {
          this.users = response || [];
        });
    },
    selectWarehouse() {
      if (!this.$route.params.id) {
        return;
      }

      this.title = this.$t("STOCK.WAREHOUSES.EDIT");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");

      return this.$store
        .dispatch(GET_STOCK_WAREHOUSE, this.$route.params.id)
        .then((response) => {
          this.requestData = {
            organization_id: response.organization?.id || null,
            country_id: response.country?.id || null,
            code: response.code || "",
            name: response.name || "",
            type: response.type || "physical",
            virtual_subtype: response.virtual_subtype || null,
            address: response.address || "",
            contact_name: response.contact_name || "",
            contact_phone: response.contact_phone || "",
            storage_capabilities: response.storage_capabilities || "",
            notice_hours: response.notice_hours,
            capacity_palettes: response.capacity_palettes,
            is_active: !!response.is_active,
            user_ids: response.user_ids || [],
          };
        });
    },
    back(check) {
      if (check && this.hasChanges) {
        this.showConfirmSet = true;
        return;
      }

      this.hasChanges = false;
      this.$router.push({ name: "stock-warehouses" });
    },
    store() {
      this.$refs.requestData.validate();
      if (!this.validRequestData) {
        return;
      }

      this.validationErrors = {};

      let action = CREATE_STOCK_WAREHOUSE;
      let payload = this.requestData;

      if (this.$route.params.id) {
        action = UPDATE_STOCK_WAREHOUSE;
        payload = {
          id: this.$route.params.id,
          params: this.requestData,
        };
      }

      this.isProcessing = true;
      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response && response.id ? response.id : this.$route.params.id;

          if (blinkId) {
            userStateService.setState(
              "table-state.stock-warehouses-table.blinkRowItemKey",
              blinkId
            );
          }

          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.hasChanges = false;
          this.$router.push({ name: "stock-warehouses" });
        })
        .catch((error) => {
          this.setValidationErrors(error);
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
